import React, { FC, MouseEvent } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { steamAccountCountries } from '@entities/country';
import { ChoiseChip } from '@shared/ui/molecules';
import { useCyberStore } from '@entities/tsp';
import { ArrayElement } from '@shared/lib/types';
import { Carousel } from '@shared/ui/organisms';
const SteamAccountCountrySwitcher: FC = () => {
  const {
    activeCountrySteam,
    setActiveCountrySteam
  } = useCyberStore();
  const handleCountrySwitch = (e: MouseEvent<HTMLElement>, country: ArrayElement<typeof steamAccountCountries>) => {
    setActiveCountrySteam(country.label);
    e.currentTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  };
  return <Carousel>
      <SteamAccountCountrySwitcherWrapper>
        <CountrySwitcherButtonsWrapper>
          {steamAccountCountries.map(country => <ChoiseChip key={country.label} size={{
          desktop: 'l',
          mobile: 'm'
        }} icon={<Image src={country.icon} alt={country.label} width={24} height={24} />} variant={activeCountrySteam === country.label ? 'selected' : 'default'} onClick={e => handleCountrySwitch(e, country)} tooltip={country.tooltip}>
              {country.label}
            </ChoiseChip>)}
        </CountrySwitcherButtonsWrapper>
      </SteamAccountCountrySwitcherWrapper>
    </Carousel>;
};
export default SteamAccountCountrySwitcher;
const SteamAccountCountrySwitcherWrapper = /*#__PURE__*/styled('div')({
  name: "SteamAccountCountrySwitcherWrapper",
  class: "s98fpdx",
  propsAsIs: false
});
const CountrySwitcherButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "CountrySwitcherButtonsWrapper",
  class: "c2jqxcc",
  propsAsIs: false
});

require("./SteamAccountCountrySwitcher.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamAccountCountrySwitcher.tsx");